import types from './actionTypes';

const initialState = {
  loading: false,
  leadForms: [],
  error: '',
};

const leadFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_LEAD_FORM_STATE:
      return initialState;
    case types.CREATE_LEAD_FORM.REQUEST:
    case types.UPDATE_LEAD_FORM.REQUEST:
    case types.SYNC_LEAD_FORMS.REQUEST:
    case types.SORT_LEAD_FORMS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_LEAD_FORM.SUCCESS:
    case types.UPDATE_LEAD_FORM.SUCCESS:
    case types.SORT_LEAD_FORMS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_LEAD_FORMS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        leadForms: [...action.leadForms],
      };
    case types.CREATE_LEAD_FORM.FAILURE:
    case types.UPDATE_LEAD_FORM.FAILURE:
    case types.SYNC_LEAD_FORMS.FAILURE:
    case types.SORT_LEAD_FORMS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default leadFormReducer;
